import filters from './Rules/behaviorRuleFilters';
import availableSegmentRules from './Rules/behaviorSegmentRules';

const queryToPreset = (ruleKey, filerKey, query) => {
  return {
    ...availableSegmentRules.find((r) => r.key === ruleKey),
    filters: [
      { ...filters[filerKey], values: [query.id] },
      {
        name: 'Time',
        field: 'timestamp',
        inputType: 'dateRange',
        conditionType: 'absoluteTimeRange',
        values: [query.startDate, query.endDate],
      },
    ],
  };
};

const segmentPresets = (query) => {
  const presets = {
    pushNotificationSend: [queryToPreset('sentPush', 'pushNotificationId', query)],
    pushNotificationDelivery: [queryToPreset('deliveredPush', 'pushNotificationId', query)],
    pushNotificationClicks: [queryToPreset('clickedPush', 'pushNotificationId', query)],
    pushNotificationBounce: [queryToPreset('bouncedPush', 'pushNotificationId', query)],
    pushNotificationConversion: [queryToPreset('addedToCart', 'pushNotificationId', query)],
    pushNotificationPurchase: [queryToPreset('purchased', 'pushNotificationId', query)],

    emailSendForEmail: [queryToPreset('sentEmail', 'emailId', query)],
    emailDeliveryForEmail: [queryToPreset('deliveredEmail', 'emailId', query)],
    emailOpenForEmail: [queryToPreset('openedEmail', 'emailId', query)],
    emailClickForEmail: [queryToPreset('clickedEmail', 'emailId', query)],
    emailBounceForEmail: [queryToPreset('bouncedEmail', 'emailId', query)],
    emailComplaintForEmail: [queryToPreset('emailComplaint', 'emailId', query)],
    emailPurchaseForEmail: [queryToPreset('purchased', 'emailId', query)],

    emailOpenForCampaign: [queryToPreset('openedEmail', 'campaignId', query)],
    emailClickForCampaign: [queryToPreset('clickedEmail', 'campaignId', query)],
    emailBounceForCampaign: [queryToPreset('bouncedEmail', 'campaignId', query)],
    emailComplaintForCampaign: [queryToPreset('emailComplaint', 'campaignId', query)],
    emailConversionForCampaign: [queryToPreset('addedToCart', 'campaignId', query)],
    emailPurchaseForCampaign: [queryToPreset('purchased', 'campaignId', query)],

    textMessageSend: [queryToPreset('sentTextMessage', 'textMessageId', query)],
    textMessageClicks: [queryToPreset('clickedTextMessage', 'textMessageId', query)],
    textMessageConversion: [queryToPreset('addedToCart', 'textMessageId', query)],
    textMessagePurchase: [queryToPreset('purchased', 'textMessageId', query)],

    viberMessageSend: [queryToPreset('sentViberMessage', 'viberMessageId', query)],
    viberMessageClicks: [queryToPreset('clickedViberMessage', 'viberMessageId', query)],
    viberMessageConversion: [queryToPreset('addedToCart', 'viberMessageId', query)],
    viberMessagePurchase: [queryToPreset('purchased', 'viberMessageId', query)],

    whatsappMessageSend: [queryToPreset('sentWhatsappMessage', 'whatsappMessageId', query)],
    whatsappMessageClicks: [queryToPreset('clickedWhatsappMessage', 'whatsappMessageId', query)],
    whatsappMessageOpen: [queryToPreset('openedWhatsappMessage', 'whatsappMessageId', query)],
    whatsappMessageDelivery: [queryToPreset('whatsappMessageDelivery', 'whatsappMessageId', query)],
    whatsappMessageBounce: [queryToPreset('whatsappMessageBounce', 'whatsappMessageId', query)],
    whatsappMessagePurchase: [queryToPreset('purchased', 'whatsappMessageId', query)],
    whatsappMessageConversion: [queryToPreset('addedToCart', 'whatsappMessageId', query)],

    webhookSend: [queryToPreset('webhookSent', 'webhookId', query)],
    webhookClicks: [queryToPreset('webhookClicked', 'webhookId', query)],
    webhookBounce: [queryToPreset('webhookBounced', 'webhookId', query)],
    webhookConversion: [queryToPreset('addedToCart', 'webhookId', query)],
    webhookPurchase: [queryToPreset('purchased', 'webhookId', query)],
  };

  return presets[query.preset];
};

export default segmentPresets;
